/* HV storefront measurement: existing PostHog destination, Shopify consent. */
(function (w, d) {
  'use strict';
  if (w.HVTracking) return;
  var callbacks = [], started = false, paused = false;
  function allowed() {
    try { return w.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function capture(name, props) {
    if (!allowed() || !w.posthog || typeof w.posthog.capture !== 'function') return false;
    if (w.posthog.has_opted_out_capturing && w.posthog.has_opted_out_capturing() === true) return false;
    try { w.posthog.capture(name, Object.assign({measurement_source: 'hv_theme_v3'}, props)); return true; }
    catch (_) { return false; }
  }
  function consentChanged() {
    if (!allowed()) {
      if (started && w.posthog && w.posthog.opt_out_capturing) { w.posthog.opt_out_capturing(); paused = true; }
      return;
    }
    if (paused && w.posthog && w.posthog.opt_in_capturing) { w.posthog.opt_in_capturing({captureEventName: false}); paused = false; }
    callbacks.splice(0).forEach(function (fn) { try { started = true; fn(); } catch (_) {} });
    if (w.__hvPostHogBridge) w.__hvPostHogBridge.ready();
  }
  function whenAllowed(fn) { if (allowed()) { started = true; fn(); } else callbacks.push(fn); }
  function lineProps(line, currency, eventId) {
    var cents = line.final_price != null ? line.final_price : line.price;
    var quantity = Number(line.quantity);
    if (!line.id || cents == null || !Number.isFinite(Number(cents)) || !Number.isFinite(quantity) || quantity <= 0) return null;
    var allocation = line.selling_plan_allocation;
    return {product_id: line.product_id, variant_id: line.variant_id || line.id,
      product_title: line.product_title || line.title, price: Number(cents) / 100,
      quantity: quantity, value: Number(cents) * quantity / 100, currency: currency,
      selling_plan_id: allocation && allocation.selling_plan && allocation.selling_plan.id || null,
      cart_operation_id: eventId};
  }
  w.HVTracking = {capture: capture, whenAllowed: whenAllowed, allowed: allowed};
  var original = w.fetch;
  if (original) w.fetch = function (input, init) {
    var target, operation, permitted = allowed();
    try { target = new URL(typeof input === 'string' ? input : input.url, w.location.href); }
    catch (_) { return original.apply(this, arguments); }
    if (target.origin === w.location.origin) {
      if (/\/cart\/add(?:\.js)?$/.test(target.pathname)) operation = 'add';
      else if (/\/cart\/(?:change|clear)(?:\.js)?$/.test(target.pathname)) operation = 'update';
      else if (/\/cart\/update(?:\.js)?$/.test(target.pathname) && init && typeof init.body === 'string') {
        try { if (JSON.parse(init.body).updates) operation = 'update'; } catch (_) {}
      }
    }
    var promise = original.apply(this, arguments);
    if (operation && permitted) promise.then(function (response) {
      if (!response.ok || !allowed()) return;
      response.clone().json().then(function (data) {
        var currency = data.currency || d.documentElement.getAttribute('data-hv-currency');
        var id = w.crypto && w.crypto.randomUUID ? w.crypto.randomUUID() : String(Date.now()) + '-' + Math.random();
        if (operation === 'add') {
          (Array.isArray(data.items) ? data.items : [data]).forEach(function (line) {
            var props = lineProps(line, currency, id);
            if (props) capture('product_added_to_cart', props);
          });
        } else if (Array.isArray(data.items) && Number.isFinite(data.total_price)) {
          capture('cart_updated', {item_count: data.item_count, cart_value: data.total_price / 100,
            currency: currency, cart_operation_id: id,
            items: data.items.map(function (line) { return lineProps(line, currency, id); }).filter(Boolean)});
        }
      }).catch(function () {});
    }).catch(function () {});
    return promise;
  };
  d.addEventListener('visitorConsentCollected', consentChanged);
  var attempts = 0;
  function loadPrivacy() {
    if (w.Shopify && w.Shopify.loadFeatures) {
      w.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function (error) { if (!error) consentChanged(); });
    } else if (++attempts < 40) w.setTimeout(loadPrivacy, 250);
  }
  loadPrivacy();
})(window, document);
